import { CodeResponse, useGoogleLogin } from "@react-oauth/google";
import { HubCallbacksNames, ICalendarSynchronized } from "api/hub";
import settingService from "api/settingsService";
import CalendarIcon from "assets/icons/calendar.svg?react";
import PIIcon from "assets/icons/filters/pi.svg?react";
import PolandIcon from "assets/icons/filters/poland.svg?react";
import DraftIcon from "assets/icons/draft.svg?react";
import ArrowsIcon from "assets/icons/arrows.svg?react";
import OauthPopup from "components/OauthPopup";
import Spinner from "components/Spinner";
import {
  ICourtPortalSettings,
  IUserCourtPortal,
} from "dto/Settings/ICourtPortalSettings";
import { IExternalIntegration } from "dto/Settings/IIntegrationsResponse";
import { IntegrationProvider } from "dto/Settings/IntegrationProvider";
import { IntegrationType } from "dto/Settings/IntegrationType";
import { useEffect, useState } from "react";
import { getErrorMessage } from "utils/getErrorMessage";
import { ENotificationType, notification } from "utils/notification";
import IntegrationMenu from "../IntegrationMenu";
import { SignalRContext } from "./../../../App";
import styles from "./styles.module.scss";
import { FC, Props } from "./typings";
import ConfirmModal from "components/ConfirmModal";
import Button from "components/Button";
import MicrosoftIcon from "assets/icons/filters/Microsoft.svg?react";
import AppleIcon from "assets/icons/apple.svg?react";
import ReloadIcon from "assets/icons/reverse.svg?react";
import GoogleIcon from "assets/icons/filters/Google.svg?react";
import EditIcon from "assets/icons/edite.svg?react";
import DisconnectIcon from "assets/icons/disconnect.svg?react";
import KSeFIcon from "assets/icons/ksef.svg?react";
import CreditIcon from "assets/icons/credit_card.svg?react";
import { logger } from "utils/logger";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import DropdownLogic from "components/DropdownLogic";
import { Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";
import CourtPortalSettings from "../CourtPortalSettings";
import CalendarSettings from "../Integrations/CalendarSettings";
import KSeFSettings from "../Integrations/KSeFSettings";
import CruSettings from "../Integrations/CruSettings";
import cruService from "api/cruService";
import { FontAwesomeIcon as FaIcon } from "@fortawesome/react-fontawesome";
import { faFileContract } from "@fortawesome/free-solid-svg-icons";
const IntegrationsTab: FC<Props> = ({ showTabBar, only }) => {
  const { t } = useTranslation();
  SignalRContext.useSignalREffect(
    HubCallbacksNames.CalendarSynchronized,
    (message: ICalendarSynchronized) => {
      setCalendarState({ ...calendarState, lastSync: message.syncDate });
    },
    [],
  );

  let scopes = [] as string[];

  const scopesCalendar = [
    "https://www.googleapis.com/auth/calendar",
    "https://www.googleapis.com/auth/tasks",
  ] as string[];

  const scopesEmail = [
    "https://mail.google.com/",
    "https://www.googleapis.com/auth/contacts.readonly",
  ] as string[];

  const scopesDrive = [
    "https://www.googleapis.com/auth/documents",
    "https://www.googleapis.com/auth/drive",
  ] as string[];

  const { mutate: updateSettings } =
    settingService.useUpdateCourtPortalSettings();

  const {
    data: integrationsData,
    isSuccess: isLoaded,
    refetch: refetchI,
  } = settingService.useGetIntegrationSettings();

  const { mutate: configureIntegration } =
    settingService.useConfigureIntegration();

  const { mutate: removeIntegration } = settingService.useRemoveIntegration();

  const { mutate: getMsRedirect } = settingService.useGetMsredirect();

  const [activeIntegrations, setActiveIntegrations] =
    useState<Array<IExternalIntegration> | null>(null);

  const [activeIntegrationModal, setActiveIntegrationModal] =
    useState<IExternalIntegration>(null);

  const [activeCourtPortal, setActiveCourtPortal] =
    useState<IUserCourtPortal>(null);

  const [activeCalendar, setActiveCalendar] = useState<number>(null);
  const [activeKsef, setActiveKsef] = useState<number>(null);

  // CRU nie jest wierszem w Integrations (klucz API per firma w CruConfigurations) —
  // stan bierzemy z cruService; karta widoczna, gdy firma ma zapisany klucz.
  const [activeCru, setActiveCru] = useState(false);
  const [cruMenu, setCruMenu] = useState(false);
  const { data: cruSettings, refetch: refetchCru } = cruService.useGetSettings(!only);

  const [showMenu, setShowMenu] = useState(false);
  const [configureAppleCalendar, setConfigureAppleCalendar] = useState(false);

  const [selectedIntegration, setSelectedIntegration] =
    useState<IntegrationType | null>(null);
  const [toDelete, setToDelete] = useState<{
    id: number;
    show: boolean;
    isCourt?: boolean;
    isMain?: boolean;
    callback?: () => void | undefined;
  }>({
    id: 0,
    show: false,
    isCourt: false,
    callback: () => {},
  });

  const [removeExistingCalendar, setRemoveExistingCalendar] = useState<{
    id: number;
    show: boolean;
    callback?: () => void | undefined;
  }>({
    id: 0,
    show: false,
    callback: () => {},
  });

  const [, setConfIMAP] = useState(false);

  const [courtPortalState, setCourtPortalState] = useState({
    id: 0,
    isActive: false,
    lastSync: "",
  });

  const { data: settingsData, refetch: refetchportals } =
    settingService.useGetCourtPortalSettings();

  const [syncPortals, setSyncPortals] = useState<IUserCourtPortal[]>([]);

  // useMemo(
  //   () =>
  //     (settingsData?.data as ICourtPortalSettings)?.Portals.filter(
  //       (p) => p.IsActive
  //     ) ?? [],
  //   [settingsData]
  // );

  useEffect(() => {
    setSyncPortals(
      (settingsData?.data as ICourtPortalSettings)?.Portals.filter(
        (p) => p.IsActive,
      ) ?? [],
    );
  }, [settingsData?.data]);

  const [calendarState, setCalendarState] = useState({
    id: 0,
    lastSync: "",
    name: "",
    microsoftActive: false,
    gmailActive: false,
    appleActive: false,
    showModal: false,
  });

  const [editorState, setEditorState] = useState({
    id: 0,
    name: "",
    microsoftActive: false,
    microsoftLastSync: "",
    gmailActive: false,
    gmailLastSync: "",
    showModal: false,
  });

  const [, setFkState] = useState({
    id: 0,
    name: "",
    wfirmaActive: false,
  });

  const [ksefState, setKsefState] = useState({
    id: 0,
    name: "",
    isActive: false,
  });

  const [msRedirecUrl, setMsRedirecUrl] = useState("");

  const selectIntegration = (type: IntegrationType | null) => {
    setSelectedIntegration(type);
    showTabBar(!type);
  };

  const onInnerViewCanceled = () => {
    selectIntegration(null);
  };

  const onInnerViewSaved = () => {
    selectIntegration(null);
  };

  const handleDisconnect = (
    id: number,
    callback?: () => void,
    isCourt?: boolean,
    isMain?: boolean,
  ) => {
    //@ts-ignore
    setToDelete({
      id: id,
      show: true,
      callback: callback,
      isCourt: isCourt ?? false,
      isMain: isMain ?? false,
    });
  };

  const handleDisconnectConfirmed = (
    integrationId: number,
    type?: IntegrationType,
  ) => {
    removeIntegration(
      { Id: integrationId },
      {
        onSuccess() {
          if (type != null) {
            switch (type) {
              case IntegrationType.Email:
                setActiveIntegrations(
                  activeIntegrations.filter((x) => x.Id !== integrationId),
                );
                break;
              case IntegrationType.Calendar:
                setCalendarState({
                  ...calendarState,
                  id: 0,
                  gmailActive: false,
                  microsoftActive: false,
                });
                break;
              case IntegrationType.Editor:
                setEditorState({
                  ...editorState,
                  id: 0,
                  gmailActive: false,
                  microsoftActive: false,
                });
                break;
              case IntegrationType.PublicPortal:
                setCourtPortalState({
                  ...courtPortalState,
                  id: 0,
                  isActive: false,
                });
                break;
              case IntegrationType.KSeF:
                setKsefState({
                  ...ksefState,
                  id: 0,
                  isActive: false,
                });
                break;
            }

            setCourtPortalState({
              ...courtPortalState,
              id: 0,
              isActive: false,
            });
          }
          refetchI();
          setSelectedIntegration(null);
        },
        onError(e: any) {
          notification({
            title: t("integrations.removeIntegrationFailed"),
            text: getErrorMessage(e.response.data),
            type: ENotificationType.ERROR,
          });
        },
      },
    );
  };

  const [activeConfigType, setActiveConfigType] =
    useState<IntegrationType | null>(null);

  useEffect(() => {
    if (isLoaded) {
      const active: Array<IExternalIntegration> = integrationsData?.data.Active;
      setActiveIntegrations(active);

      const activeCalendar = active?.find(
        (a) => a.Type === IntegrationType.Calendar,
      );

      if (activeCalendar) {
        setCalendarState({
          ...calendarState,
          id: activeCalendar.Id,
          name: activeCalendar.Name,
          lastSync: activeCalendar.LastSync ?? "",
          microsoftActive:
            activeCalendar.Provider === IntegrationProvider.Microsoft,
          gmailActive: activeCalendar.Provider === IntegrationProvider.Google,
          appleActive: activeCalendar.Provider === IntegrationProvider.Apple,
        });
      } else {
        setCalendarState({
          ...calendarState,
          id: null,
          name: null,
          lastSync: "",
          microsoftActive: false,
          gmailActive: false,
          appleActive: false,
        });
      }

      const activeEditor = active?.find((a) => a.Type === IntegrationType.Editor);
      if (activeEditor) {
        setEditorState({
          ...editorState,
          name: activeEditor.Name,
          id: activeEditor.Id,
          microsoftActive:
            activeEditor.Provider === IntegrationProvider.Microsoft,
          microsoftLastSync:
            activeEditor.Provider === IntegrationProvider.Microsoft
              ? activeEditor.LastSync ?? ""
              : "",
          gmailActive: activeEditor.Provider === IntegrationProvider.Google,
          gmailLastSync:
            activeEditor.Provider === IntegrationProvider.Google
              ? activeEditor.LastSync ?? ""
              : "",
        });
      } else {
        setEditorState({
          ...editorState,
          name: "",
          id: null,
          microsoftActive: false,
          microsoftLastSync: null,
          gmailActive: false,
          gmailLastSync: null,
        });
      }

      const activeCourtPortal = active?.find(
        (a) => a.Type === IntegrationType.PublicPortal,
      );

      if (activeCourtPortal) {
        setCourtPortalState({
          id: activeCourtPortal.Id,
          isActive: true,
          lastSync: activeCourtPortal.LastSync ?? "",
        });
      } else {
        setCourtPortalState({ id: 0, isActive: false, lastSync: "" });
      }

      const activeFk = active?.find(
        (a) => a.Type === IntegrationType.InvoiceSystem,
      );

      if (activeFk) {
        setFkState({
          id: activeFk.Id,
          wfirmaActive: true,
          name: activeFk.Name,
        });
      } else {
        setFkState({ id: 0, wfirmaActive: false, name: "" });
      }

      const activeKsef = active?.find((a) => a.Type === IntegrationType.KSeF);

      if (activeKsef) {
        setKsefState({
          id: activeKsef.Id,
          isActive: true,
          name: activeKsef.Name,
        });
      } else {
        setKsefState({ id: 0, isActive: false, name: "" });
      }
    }
  }, [integrationsData]);

  const handleClick = (
    type: IntegrationType,
    provider: IntegrationProvider,
    isActive: boolean,
  ) => {
    if (!isActive) {
      if (type === IntegrationType.Calendar) {
        if (
          calendarState.appleActive ||
          calendarState.gmailActive ||
          calendarState.microsoftActive
        ) {
          setShowMenu(false);
          setRemoveExistingCalendar({
            id: calendarState.id,
            show: true,
            callback: () => {
              setCalendarState({
                ...calendarState,
                appleActive: false,
                gmailActive: false,
                microsoftActive: false,
              });

              if (provider === IntegrationProvider.Apple) {
                setShowMenu(true);
                setConfigureAppleCalendar(true);
              } else {
                setTimeout(() => {
                  handleClick(type, provider, false);
                }, 1000);
              }
            },
          });
          return;
        }
      }

      switch (provider) {
        case IntegrationProvider.Google: {
          initGoogle(type);
          break;
        }
        case IntegrationProvider.Microsoft: {
          initMicrosoft(type);
          break;
        }
        case IntegrationProvider.Apple: {
          if (type === IntegrationType.Calendar) {
            setConfigureAppleCalendar(true);
          }
          break;
        }
        case IntegrationProvider.CourtPortal: {
          setSelectedIntegration(IntegrationType.PublicPortal);
          break;
        }
        case IntegrationProvider.Imap: {
          setConfIMAP(true);
          break;
        }
      }
    } else {
      switch (type) {
        case IntegrationType.Email:
          // setToDelete({
          //   id: emailState.id,
          //   show: true,
          //   callback: () =>
          //     setEmailState({
          //       ...emailState,
          //       microsoftActive: false,
          //       gmailActive: false,
          //       imapActive: false,
          //     }),
          // });
          return;
        case IntegrationType.Calendar:
          setToDelete({
            id: calendarState.id,
            show: true,
            callback: () =>
              setCalendarState({
                ...calendarState,
                appleActive: false,
                gmailActive: false,
              }),
          });
          return;
        case IntegrationType.Editor:
          setToDelete({
            id: editorState.id,
            show: true,
            callback: () => {
              setEditorState({
                ...editorState,
                gmailActive: false,
                microsoftActive: false,
              });
            },
          });
          return;
        default:
          setSelectedIntegration(type);
          return;
      }
    }
  };

  const handleGoogleSuccess = (
    codeResponse: Omit<
      CodeResponse,
      "error" | "error_description" | "error_uri"
    >,
    scopes,
  ) => {
    if (codeResponse) {
      let missing = false;
      scopes?.forEach((s) => {
        if (codeResponse.scope.indexOf(s) < 0) {
          missing = true;
        }
      });

      if (missing) {
        notification({
          title: t("integrations.insufficientPermissions"),
          text: t("integrations.integrationSetupFailed"),
          type: ENotificationType.ERROR,
        });
        return;
      }

      configureIntegration(
        {
          Provider: IntegrationProvider.Google,
          Type: activeConfigType!,
          Code: codeResponse.code,
          Scope: codeResponse.scope,
        },
        {
          onSuccess(data) {
            const resp: IExternalIntegration = data.data;

            switch (activeConfigType) {
              case IntegrationType.Email:
                // setEmailState({
                //   ...emailState,
                //   id: resp.Id,
                //   microsoftActive: false,
                //   gmailActive: true,
                //   gmailLastSync: "",
                // });
                break;
              case IntegrationType.Calendar:
                setCalendarState({
                  ...calendarState,
                  id: resp.Id,
                  microsoftActive: false,
                  appleActive: false,
                  gmailActive: true,
                  lastSync: "",
                });
                break;
              case IntegrationType.Editor:
                setEditorState({
                  ...editorState,
                  id: resp.Id,
                  microsoftActive: false,
                  gmailActive: true,
                  gmailLastSync: "",
                });
                break;
            }

            setShowMenu(false);
            setActiveConfigType(null);
            refetchI();
          },
          onError(e: any) {
            notification({
              title: t("integrations.configureFailed"),
              text: getErrorMessage(e.response.data),
              type: ENotificationType.ERROR,
            });
          },
        },
      );
    }
  };

  const loginGoogleCalendar = useGoogleLogin({
    scope: scopesCalendar?.join(" "),
    flow: "auth-code",
    onSuccess: (codeResponse) => {
      handleGoogleSuccess(codeResponse, scopesCalendar);
    },
  });

  const loginGoogleEmail = useGoogleLogin({
    scope: scopesEmail?.join(" "),
    flow: "auth-code",
    onSuccess: (codeResponse) => {
      handleGoogleSuccess(codeResponse, scopesEmail);
    },
  });

  const loginGoogleDrive = useGoogleLogin({
    scope: scopesDrive?.join(" "),
    flow: "auth-code",
    onSuccess: (codeResponse) => {
      handleGoogleSuccess(codeResponse, scopesDrive);
    },
  });

  const initGoogle = (type: IntegrationType) => {
    setActiveConfigType(type);

    switch (type) {
      case IntegrationType.Email:
        loginGoogleEmail();
        break;
      case IntegrationType.Calendar:
        loginGoogleCalendar();
        break;
      case IntegrationType.Editor:
        loginGoogleDrive();
        break;
    }
  };

  const initMicrosoft = (type: IntegrationType) => {
    logger.log("init microsoft called", type);
    setActiveConfigType(type);

    scopes = ["user.read", "calendars.readwrite"];

    if (type === IntegrationType.Editor) {
      scopes = ["user.read", "files.readwrite.all"];
    } else if (type === IntegrationType.Email) {
      scopes = [
        "user.read",
        "mail.readwrite",
        "mail.send",
        "contacts.readwrite",
      ];
    }

    getMsRedirect(
      { scopes: scopes.join(", ") },
      {
        onSuccess(data) {
          const url = data.data.Url;
          logger.log("Got ms redirect url", url);
          setMsRedirecUrl(url);
        },
      },
    );
  };

  const onCode = (code: any, params: any) => {
    scopes = ["user.read", "calendars.readwrite"];

    if (activeConfigType === IntegrationType.Editor) {
      scopes = ["user.read", "files.readwrite.all"];
    } else if (activeConfigType === IntegrationType.Email) {
      scopes = [
        "user.read",
        "mail.readwrite",
        "mail.send",
        "contacts.readwrite",
      ];
    }

    configureIntegration(
      {
        Provider: IntegrationProvider.Microsoft,
        Type: activeConfigType!,
        Code: code,
        Scope: scopes!.join(", "),
      },
      {
        onSuccess(data) {
          const resp: IExternalIntegration = data.data;

          switch (activeConfigType) {
            case IntegrationType.Email:
              // setEmailState({
              //   ...emailState,
              //   id: resp.Id,
              //   microsoftActive: true,
              //   gmailActive: false,
              //   gmailLastSync: "",
              // });

              break;
            case IntegrationType.Calendar:
              setCalendarState({
                ...calendarState,
                id: resp.Id,
                microsoftActive: true,
                appleActive: false,
                gmailActive: false,
                lastSync: "",
              });
              break;
            case IntegrationType.Editor:
              setEditorState({
                ...editorState,
                id: resp.Id,
                microsoftActive: true,
                gmailActive: false,
                gmailLastSync: "",
              });
              break;
          }

          setShowMenu(false);
          setActiveConfigType(null);
          setMsRedirecUrl(null);
          refetchI();
        },
        onError(e: any) {
          notification({
            title: t("integrations.configureFailed"),
            text: getErrorMessage(e.response.data),
            type: ENotificationType.ERROR,
          });
          setMsRedirecUrl(null);
        },
      },
    );
  };
  const onClose = () => {};

  if (!integrationsData) {
    return <Spinner></Spinner>;
  }

  if (showMenu) {
    return (
      <>
        <OauthPopup
          width={400}
          height={600}
          title={t("common.signIn")}
          url={msRedirecUrl}
          onClose={onClose}
          onCode={onCode}
        >
          <div></div>
        </OauthPopup>
        <IntegrationMenu
          refetchportals={refetchportals}
          toggle={() => setShowMenu(false)}
          integrationId={courtPortalState.id}
          onInnerViewCanceled={onInnerViewCanceled}
          onInnerViewSaved={onInnerViewSaved}
          handleDisconnect={handleDisconnect}
          courtPortalState={courtPortalState}
          refetchI={refetchI}
          handleClick={handleClick}
          configureAppleCalendar={configureAppleCalendar}
          setConfigureAppleCalendar={setConfigureAppleCalendar}
        />
      </>
    );
  }

  console.log(syncPortals);

  const handlePiModal = (id) => {
    const copy = [...syncPortals];
    const portal = copy.find((x) => x.Id === id);

    if (portal) {
      portal.showModal = !portal.showModal;
    }

    setSyncPortals(copy);
  };

  if (activeCourtPortal) {
    return (
      <CourtPortalSettings
        integrationId={courtPortalState?.id}
        onCanceled={() => setActiveCourtPortal(null)}
        refetchI={refetchI}
        handleDisconnect={handleDisconnect}
        onSaved={() => setActiveCourtPortal(null)}
        refetchportals={refetchportals}
      ></CourtPortalSettings>
    );
  }

  if (activeCalendar) {
    return (
      <CalendarSettings
        integrationId={activeCalendar}
        onCanceled={() => setActiveCalendar(null)}
        handleDisconnect={handleDisconnect}
        onSaved={() => setActiveCalendar(null)}
        refetchI={refetchI}
      ></CalendarSettings>
    );
  }

  if (activeCru) {
    return (
      <CruSettings
        onCanceled={() => setActiveCru(false)}
        onSaved={() => {
          refetchCru();
          setActiveCru(false);
        }}
        onDisconnected={() => {
          refetchCru();
          setActiveCru(false);
        }}
      />
    );
  }

  if (activeKsef) {
    return (
      <KSeFSettings
        integrationId={activeKsef}
        onCanceled={() => setActiveKsef(null)}
        handleDisconnect={handleDisconnect}
        onSaved={() => setActiveKsef(null)}
        refetchI={refetchI}
      ></KSeFSettings>
    );
  }

  return (
    <>
      <div className={styles.wrapper}>
        {!only && (
          <>
            <div className={styles.title}>
              <ArrowsIcon></ArrowsIcon>
              {t("integrations.title")}
            </div>
            <div className={styles.subtitle}>
              {t("integrations.activeIntegrations")}
            </div>
            <div className={styles.hint}>{t("integrations.description")}</div>
          </>
        )}

        <div className={styles.list}>
          {!only && cruSettings?.HasApiKey && (
            <div className={styles.box}>
              <div className={styles.boxHeader}>
                <div className={styles.boxTitle}>
                  <FaIcon icon={faFileContract} style={{ fontSize: 20, color: "#5d49c7" }} />
                  Centralny Rejestr Umów (CRU)
                </div>
              </div>
              <div className={styles.boxList}>
                <div
                  className={classNames(
                    styles.integration,
                    !cruSettings.IsActive ? styles.error : null,
                  )}
                >
                  <div className={styles.s}>
                    <FaIcon icon={faFileContract} className={styles.icon} />
                    {cruSettings.InstitutionRegon
                      ? `REGON ${cruSettings.InstitutionRegon}`
                      : "klucz API"}{" "}
                    <div
                      className={styles.expanderWrapper}
                      onClick={(e) => {
                        e.stopPropagation();
                        setCruMenu(true);
                      }}
                    >
                      <FontAwesomeIcon
                        className={classNames(styles.expander)}
                        icon={faCaretDown}
                      />
                    </div>
                  </div>
                </div>
                {cruMenu && (
                  <DropdownLogic
                    className={styles.dropdownWrapper}
                    toggle={() => setCruMenu(false)}
                  >
                    <div className={`${styles.dropdown}`}>
                      <div className={styles.hdr}>
                        <FaIcon icon={faFileContract} className={styles.icon} />
                        <div className={styles.t}>
                          Centralny Rejestr Umów
                          <div className={styles.sub}>
                            {cruSettings.IsActive
                              ? `klucz ważny do ${new Date(cruSettings.KeyValidTo!).toLocaleDateString("pl-PL")}`
                              : "klucz wygasł"}
                          </div>
                        </div>
                      </div>
                      <div className={styles.options}>
                        <div
                          onClick={(e) => {
                            setActiveCru(true);
                            setCruMenu(false);
                            e.preventDefault();
                          }}
                          className={styles.dropdownBox}
                        >
                          <EditIcon></EditIcon> {t("common.edit")}
                        </div>
                      </div>
                      <div className={styles.state}>
                        <div
                          className={classNames(
                            styles.active,
                            cruSettings.IsActive ? styles.ok : null,
                          )}
                        >
                          {cruSettings.IsActive ? "Integracja aktywna" : "Klucz API wygasł"}
                        </div>
                      </div>
                    </div>
                  </DropdownLogic>
                )}
              </div>
            </div>
          )}
          {only !== "ksef" && !!syncPortals.length && (
            <div className={styles.box}>
              <div className={styles.boxHeader}>
                <div className={styles.boxTitle}>
                  <PIIcon /> {t("integrations.piJudicial")}
                </div>
                <Tooltip title={t("common.refresh")}>
                  <div>
                    <ReloadIcon className={styles.refreshIcon}></ReloadIcon>
                  </div>
                </Tooltip>
              </div>
              <div className={styles.boxList}>
                {syncPortals.map((s) => (
                  <div
                    key={s.Id}
                    className={classNames(
                      styles.integration,
                      s.LastErrorMessage ? styles.error : null,
                    )}
                  >
                    <div className={classNames(styles.s)}>
                      <PolandIcon className={styles.icon} /> {s.Name}{" "}
                      <div
                        className={styles.expanderWrapper}
                        onClick={(e) => {
                          e.stopPropagation();
                          handlePiModal(s.Id);
                        }}
                      >
                        <FontAwesomeIcon
                          className={classNames(styles.expander)}
                          icon={faCaretDown}
                        />
                      </div>
                      {/* <CloseIcon
                        onClick={() => {
                          handleDisconnect(s.Id, undefined, true, s.IsMain);
                        }}
                        className={styles.closeIcon}
                      /> */}
                    </div>
                    {s.showModal && (
                      <DropdownLogic
                        className={styles.dropdownWrapper}
                        toggle={() => handlePiModal(s.Id)}
                      >
                        <div className={`${styles.dropdown}`}>
                          <div className={styles.hdr}>
                            <PIIcon />
                            <div className={styles.t}>
                              PI
                              <div className={styles.sub}>{s.Name}</div>
                            </div>
                          </div>
                          <div className={styles.options}>
                            <div
                              onClick={(e) => {
                                //setShowMenu(true);
                                setActiveCourtPortal(s);
                                e.preventDefault();
                              }}
                              className={styles.dropdownBox}
                            >
                              <EditIcon></EditIcon> {t("common.edit")}
                            </div>
                            <div
                              onClick={(e) => {
                                handlePiModal(s.Id);
                                e.preventDefault();
                              }}
                              className={styles.dropdownBox}
                            >
                              <ReloadIcon></ReloadIcon> {t("common.refresh")}
                            </div>
                          </div>
                          <div className={styles.options2}>
                            <div
                              onClick={(e) => {
                                handleDisconnect(
                                  s.Id,
                                  undefined,
                                  true,
                                  s.IsMain,
                                );
                                e.preventDefault();
                              }}
                              className={styles.dropdownBox}
                            >
                              <DisconnectIcon></DisconnectIcon>{" "}
                              {t("settings.disconnectIntegration")}
                            </div>
                          </div>
                          <div className={styles.state}>
                            <div
                              className={classNames(
                                styles.active,
                                !s.LastErrorMessage ? styles.ok : "",
                              )}
                            >
                              {s.LastErrorMessage ??
                                t("integrations.syncActive")}
                            </div>
                          </div>
                        </div>
                      </DropdownLogic>
                    )}
                  </div>
                ))}
              </div>
            </div>
          )}

          {!!calendarState.id && (
            <div className={styles.box}>
              <div className={styles.boxHeader}>
                <div className={styles.boxTitle}>
                  <CalendarIcon /> {t("integrations.calendar")}
                </div>
                <Tooltip title={t("common.refresh")}>
                  <div>
                    <ReloadIcon className={styles.refreshIcon}></ReloadIcon>
                  </div>
                </Tooltip>
              </div>
              <div className={styles.boxList}>
                <div className={styles.integration}>
                  <div className={styles.s}>
                    {calendarState.gmailActive && (
                      <GoogleIcon className={styles.icon} />
                    )}{" "}
                    {calendarState.microsoftActive && (
                      <MicrosoftIcon className={styles.icon} />
                    )}
                    {calendarState.appleActive && (
                      <AppleIcon className={styles.icon} />
                    )}
                    {calendarState.name}
                    <div
                      className={styles.expanderWrapper}
                      onClick={(e) => {
                        e.stopPropagation();
                        setCalendarState({
                          ...calendarState,
                          showModal: true,
                        });
                      }}
                    >
                      <FontAwesomeIcon
                        className={classNames(styles.expander)}
                        icon={faCaretDown}
                      />
                    </div>
                  </div>
                  {calendarState.showModal && (
                    <DropdownLogic
                      className={styles.dropdownWrapper}
                      toggle={() =>
                        setCalendarState({ ...calendarState, showModal: false })
                      }
                    >
                      <div className={`${styles.dropdown}`}>
                        <div className={styles.hdr}>
                          {calendarState.gmailActive && (
                            <GoogleIcon className={styles.icon} />
                          )}{" "}
                          {calendarState.microsoftActive && (
                            <MicrosoftIcon className={styles.icon} />
                          )}
                          <div className={styles.t}>
                            {t("integrations.calendar")}
                            <div className={styles.sub}>
                              {calendarState.name}
                            </div>
                          </div>
                        </div>
                        <div className={styles.options}>
                          <div
                            onClick={(e) => {
                              setActiveCalendar(calendarState.id);
                              e.preventDefault();
                            }}
                            className={styles.dropdownBox}
                          >
                            <EditIcon></EditIcon> {t("common.edit")}
                          </div>
                          <div
                            onClick={(e) => {
                              setCalendarState({
                                ...calendarState,
                                showModal: false,
                              });
                              e.preventDefault();
                            }}
                            className={styles.dropdownBox}
                          >
                            <ReloadIcon></ReloadIcon> {t("common.refresh")}
                          </div>
                        </div>
                        <div className={styles.options2}>
                          <div
                            onClick={(e) => {
                              handleDisconnect(calendarState.id);
                              e.preventDefault();
                            }}
                            className={styles.dropdownBox}
                          >
                            <DisconnectIcon></DisconnectIcon>{" "}
                            {t("settings.disconnectIntegration")}
                          </div>
                        </div>
                        <div className={styles.state}>
                          <div className={classNames(styles.active, styles.ok)}>
                            {t("integrations.syncActive")}
                          </div>
                        </div>
                      </div>
                    </DropdownLogic>
                  )}
                </div>
              </div>
            </div>
          )}

          {!!editorState.id && (
            <div className={styles.box}>
              <div className={styles.boxHeader}>
                <div className={styles.boxTitle}>
                  <DraftIcon className={styles.icon} />{" "}
                  {t("integrations.editor")}
                </div>
                <Tooltip title={t("common.refresh")}>
                  <div>
                    <ReloadIcon className={styles.refreshIcon}></ReloadIcon>
                  </div>
                </Tooltip>
              </div>
              <div className={styles.boxList}>
                <div className={styles.integration}>
                  <div className={styles.s}>
                    {editorState.gmailActive && (
                      <GoogleIcon className={styles.icon} />
                    )}{" "}
                    {editorState.microsoftActive && (
                      <MicrosoftIcon className={styles.icon} />
                    )}
                    {editorState.name}
                    <div
                      className={styles.expanderWrapper}
                      onClick={(e) => {
                        e.stopPropagation();
                        setEditorState({
                          ...editorState,
                          showModal: true,
                        });
                      }}
                    >
                      <FontAwesomeIcon
                        className={classNames(styles.expander)}
                        icon={faCaretDown}
                      />
                    </div>
                  </div>
                  {editorState.showModal && (
                    <DropdownLogic
                      className={styles.dropdownWrapper}
                      toggle={() =>
                        setEditorState({ ...editorState, showModal: false })
                      }
                    >
                      <div className={`${styles.dropdown}`}>
                        <div className={styles.hdr}>
                          {editorState.gmailActive && (
                            <GoogleIcon className={styles.icon} />
                          )}{" "}
                          {editorState.microsoftActive && (
                            <MicrosoftIcon className={styles.icon} />
                          )}
                          <div className={styles.t}>
                            {t("integrations.editor")}
                            <div className={styles.sub}>{editorState.name}</div>
                          </div>
                        </div>
                        <div className={styles.options}>
                          <div
                            onClick={(e) => {
                              setShowMenu(true);
                              setActiveConfigType(IntegrationType.Editor);
                              e.preventDefault();
                            }}
                            className={styles.dropdownBox}
                          >
                            <EditIcon></EditIcon> {t("common.edit")}
                          </div>
                          <div
                            onClick={(e) => {
                              setEditorState({
                                ...editorState,
                                showModal: false,
                              });
                              e.preventDefault();
                            }}
                            className={styles.dropdownBox}
                          >
                            <ReloadIcon></ReloadIcon> {t("common.refresh")}
                          </div>
                        </div>
                        <div className={styles.options2}>
                          <div
                            onClick={(e) => {
                              handleDisconnect(editorState.id);
                              e.preventDefault();
                            }}
                            className={styles.dropdownBox}
                          >
                            <DisconnectIcon></DisconnectIcon>{" "}
                            {t("settings.disconnectIntegration")}
                          </div>
                        </div>
                        <div className={styles.state}>
                          <div className={classNames(styles.active, styles.ok)}>
                            {t("integrations.syncActive")}
                          </div>
                        </div>
                      </div>
                    </DropdownLogic>
                  )}
                </div>
              </div>
            </div>
          )}

          {only !== "court" &&
            activeIntegrations &&
            activeIntegrations.filter((x) => x.Type === IntegrationType.KSeF)
              .length > 0 && (
              <div className={styles.box}>
                <div className={styles.boxHeader}>
                  <div className={styles.boxTitle}>
                    <CreditIcon></CreditIcon> KSeF
                  </div>
                  <Tooltip title={t("common.refresh")}>
                    <div>
                      <ReloadIcon className={styles.refreshIcon}></ReloadIcon>
                    </div>
                  </Tooltip>
                </div>
                <div className={styles.boxList}>
                  {activeIntegrations
                    .filter((x) => x.Type === IntegrationType.KSeF)
                    .map((x) => (
                      <div className={styles.integration}>
                        <div className={styles.s}>
                          <KSeFIcon className={styles.icon} />
                          {x.Name}{" "}
                          <div
                            className={styles.expanderWrapper}
                            onClick={(e) => {
                              e.stopPropagation();
                              setActiveIntegrationModal(x);
                            }}
                          >
                            <FontAwesomeIcon
                              className={classNames(styles.expander)}
                              icon={faCaretDown}
                            />
                          </div>
                          {/* <CloseIcon
                      onClick={() => {
                        handleDisconnect(emailState.id);
                      }}
                      className={styles.closeIcon}
                    /> */}
                        </div>
                      </div>
                    ))}
                  {activeIntegrationModal &&
                    activeIntegrationModal?.Type === IntegrationType.KSeF && (
                      <DropdownLogic
                        className={styles.dropdownWrapper}
                        toggle={() => setActiveIntegrationModal(null)}
                      >
                        <div className={`${styles.dropdown}`}>
                          <div className={styles.hdr}>
                            <KSeFIcon className={styles.icon} />
                            <div className={styles.t}>
                              KSeF
                              <div className={styles.sub}>
                                {activeIntegrationModal.Name}
                              </div>
                            </div>
                          </div>
                          <div className={styles.options}>
                            <div
                              onClick={(e) => {
                                setActiveKsef(activeIntegrationModal.Id);
                                setActiveIntegrationModal(null);
                                e.preventDefault();
                              }}
                              className={styles.dropdownBox}
                            >
                              <EditIcon></EditIcon> {t("common.edit")}
                            </div>
                            <div
                              onClick={() => {
                                setActiveIntegrationModal(null);
                              }}
                              className={styles.dropdownBox}
                            >
                              <ReloadIcon></ReloadIcon> {t("common.refresh")}
                            </div>
                          </div>
                          <div className={styles.options2}>
                            <div
                              onClick={(e) => {
                                handleDisconnect(activeIntegrationModal.Id);
                                e.preventDefault();
                              }}
                              className={styles.dropdownBox}
                            >
                              <DisconnectIcon></DisconnectIcon>{" "}
                              {t("settings.disconnectIntegration")}
                            </div>
                          </div>
                          <div className={styles.state}>
                            <div
                              className={classNames(styles.active, styles.ok)}
                            >
                              {t("integrations.syncActive")}
                            </div>
                          </div>
                        </div>
                      </DropdownLogic>
                    )}
                </div>
              </div>
            )}
        </div>
      </div>

      {only ? (
        <div className={styles.addBtnRight}>
          <Button
            className={styles.btn}
            onClick={() => setShowMenu(true)}
            text={t("integrations.addIntegration")}
          />
        </div>
      ) : (
        <Button
          className={styles.btn}
          onClick={() => setShowMenu(true)}
          text={t("integrations.addIntegration")}
        />
      )}
      {toDelete.show && (
        <ConfirmModal
          title={t("integrations.confirmDeleteTitle")}
          text={t("integrations.confirmDeleteText")}
          acceptLabel={t("common.delete")}
          cancelLabel={t("common.cancel")}
          onAccept={() => {
            if (!toDelete?.isCourt) {
              handleDisconnectConfirmed(toDelete.id, selectedIntegration);
              setToDelete({ id: 0, show: false });
              toDelete.callback?.();
            } else {
              if (toDelete.isMain) {
                removeIntegration(
                  {
                    Id: courtPortalState.id,
                  },
                  {
                    onSuccess: () => {
                      refetchportals();
                      setCourtPortalState({
                        ...courtPortalState,
                        id: 0,
                        isActive: false,
                      });
                      refetchI();
                      setToDelete({ id: 0, show: false });
                    },
                  },
                );
                return;
              }

              updateSettings(
                {
                  PortalIds: syncPortals
                    .filter((x) => x.Id !== toDelete.id)
                    .map((x) => x.Id),
                  DocumentIds: [],
                },
                {
                  onSuccess: () => {
                    refetchportals();
                    setToDelete({ id: 0, show: false });
                  },
                },
              );
            }
          }}
          onCancel={() => setToDelete({ id: 0, show: false })}
        />
      )}

      {removeExistingCalendar.show && (
        <ConfirmModal
          title={t("settings.calendarIntegrationActive")}
          text={t("integrations.calendarAlreadyConnectedText")}
          acceptLabel={t("common.unlink")}
          cancelLabel={t("common.cancel")}
          showDontShowNextTime={false}
          onAccept={() => {
            if (removeExistingCalendar?.id) {
              handleDisconnectConfirmed(
                removeExistingCalendar.id,
                IntegrationType.Calendar,
              );
              setRemoveExistingCalendar({ id: 0, show: false });
              removeExistingCalendar.callback?.();
            }
          }}
          onCancel={() => setRemoveExistingCalendar({ id: 0, show: false })}
        />
      )}
    </>
  );

  // return (
  //   <>
  //     <OauthPopup
  //       width={400}
  //       height={600}
  //       title="Zaloguj się"
  //       url={msRedirecUrl}
  //       onClose={onClose}
  //       onCode={onCode}
  //     >
  //       <div></div>
  //     </OauthPopup>
  //     <div className={styles.wrapper}>
  //       <div className={styles.menu}>
  //         <div
  //           onClick={() => setActualView(EIntegrationsViews.COURT)}
  //           className={`${styles.box}  ${
  //             actualView === EIntegrationsViews.COURT && styles.activeText
  //           }`}
  //         >
  //           PI Sądów
  //         </div>
  //         <div
  //           onClick={() => setActualView(EIntegrationsViews.EMAIL)}
  //           className={`${styles.box} ${
  //             actualView === EIntegrationsViews.EMAIL && styles.activeText
  //           }`}
  //         >
  //           Email
  //         </div>
  //         {!isGuest && (
  //           <div
  //             onClick={() => setActualView(EIntegrationsViews.CALENDAR)}
  //             className={`${styles.box} ${
  //               actualView === EIntegrationsViews.CALENDAR && styles.activeText
  //             }`}
  //           >
  //             Kalendarze
  //           </div>
  //         )}
  //         {!isGuest && (
  //           <div
  //             onClick={() => setActualView(EIntegrationsViews.EDITORS)}
  //             className={`${styles.box} ${
  //               actualView === EIntegrationsViews.EDITORS && styles.activeText
  //             }`}
  //           >
  //             Edytor dokumentów
  //           </div>
  //         )}
  //         {!isGuest && (
  //           <div
  //             onClick={() => setActualView(EIntegrationsViews.ACCOUNTANCY)}
  //             className={`${styles.box} ${
  //               actualView === EIntegrationsViews.ACCOUNTANCY &&
  //               styles.activeText
  //             }`}
  //           >
  //             System FK
  //           </div>
  //         )}
  //       </div>
  //       {selectedIntegration === null && (
  //         <>
  //           {actualView === EIntegrationsViews.COURT && (
  //             <div className={styles.groupWrapper}>
  //               <div className={styles.groupCourt}>
  //                 <div className={styles.subheader}>Integracja z PI Sądów</div>
  //                 {/* <div className={styles.hint}>
  //               Synchronizuj dokumenty z pozostałych miejsc, aby mieć
  //               wszystkie dokumenty zorganizowane w jednym miejscu.
  //             </div> */}
  //                 <div className={styles.integrationsCourt}>
  //                   <IntegrationCourtCard
  //                     type={IntegrationType.PublicPortal}
  //                     provider={IntegrationProvider.CourtPortal}
  //                     lastSync={courtPortalState.lastSync}
  //                     isActive={courtPortalState.isActive}
  //                     integrationId={courtPortalState.id}
  //                     handleDisconnect={handleDisconnect}
  //                     handleClick={handleClick}
  //                   ></IntegrationCourtCard>
  //                 </div>
  //               </div>
  //               <div className={styles.groupCourt}>
  //                 <div className={styles.subheader}>Subkonta</div>
  //               </div>
  //             </div>
  //           )}
  //           {actualView === EIntegrationsViews.EMAIL && (
  //             <div className={styles.group}>
  //               <div className={styles.subheader}>Email</div>
  //               <div className={styles.hint}>
  //                 Odbieraj swoje maile, wieszaj do spraw i obsługuj
  //                 korespondencję e-mail bezpośrednio w Nocie.
  //               </div>
  //               <div className={styles.integrations}>
  //                 <div className={styles.integrationGroup}>
  //                   <IntegrationCard
  //                     name={emailState.microsoftActive ? emailState.name : ''}
  //                     type={IntegrationType.Email}
  //                     provider={IntegrationProvider.Microsoft}
  //                     lastSync={emailState.microsoftLastSync}
  //                     isActive={emailState.microsoftActive}
  //                     handleClick={handleClick}
  //                   ></IntegrationCard>
  //                   <IntegrationCard
  //                     name={emailState.gmailActive ? emailState.name : ''}
  //                     type={IntegrationType.Email}
  //                     provider={IntegrationProvider.Google}
  //                     lastSync={emailState.gmailLastSync}
  //                     isActive={emailState.gmailActive}
  //                     handleClick={handleClick}
  //                   ></IntegrationCard>
  //                   <IntegrationCard
  //                     name={emailState.imapActive ? emailState.name : ''}
  //                     type={IntegrationType.Email}
  //                     provider={IntegrationProvider.Imap}
  //                     lastSync={emailState.imapLastSync}
  //                     isActive={emailState.imapActive}
  //                     handleClick={handleClick}
  //                   ></IntegrationCard>
  //                 </div>
  //                 <div className={styles.integrationGroup}></div>
  //               </div>
  //             </div>
  //           )}
  //           {actualView === EIntegrationsViews.CALENDAR && (
  //             <div className={styles.group}>
  //               <div className={styles.subheader}>Kalendarze</div>
  //               <div className={styles.hint}>
  //                 Synchronizuj swoje zaplanowane zadania, spotkania oraz inne
  //                 czynności z zewnętrznym kalendarzem.
  //               </div>
  //               <div className={styles.integrations}>
  //                 <div className={styles.integrationGroup}>
  //                   <IntegrationCard
  //                     type={IntegrationType.Calendar}
  //                     provider={IntegrationProvider.Microsoft}
  //                     lastSync={calendarState.lastSync}
  //                     isActive={calendarState.microsoftActive}
  //                     handleClick={handleClick}
  //                   ></IntegrationCard>
  //                   <IntegrationCard
  //                     type={IntegrationType.Calendar}
  //                     provider={IntegrationProvider.Google}
  //                     lastSync={calendarState.lastSync}
  //                     isActive={calendarState.gmailActive}
  //                     handleClick={handleClick}
  //                   ></IntegrationCard>
  //                   <IntegrationCard
  //                     type={IntegrationType.Calendar}
  //                     provider={IntegrationProvider.Apple}
  //                     lastSync={calendarState.lastSync}
  //                     isActive={calendarState.appleActive}
  //                     handleClick={handleClick}
  //                   ></IntegrationCard>
  //                 </div>

  //                 <div className={styles.integrationGroup}></div>
  //               </div>
  //             </div>
  //           )}
  //           {actualView === EIntegrationsViews.EDITORS && (
  //             <div className={styles.group}>
  //               <div className={styles.subheader}>Edytor dokumnetów</div>
  //               <div className={styles.hint}>
  //                 Edycję dokumnetów możesz prowadzić w lokalnym edytorze lub
  //                 używanym przez Ciebie edytorze online.
  //               </div>
  //               <div className={styles.integrations}>
  //                 <div className={styles.integrationGroup}>
  //                   <IntegrationCard
  //                     type={IntegrationType.Editor}
  //                     provider={IntegrationProvider.Microsoft}
  //                     lastSync={editorState.microsoftLastSync}
  //                     isActive={editorState.microsoftActive}
  //                     handleClick={handleClick}
  //                   ></IntegrationCard>
  //                   <IntegrationCard
  //                     type={IntegrationType.Editor}
  //                     provider={IntegrationProvider.Google}
  //                     lastSync={editorState.gmailLastSync}
  //                     isActive={editorState.gmailActive}
  //                     handleClick={handleClick}
  //                   ></IntegrationCard>
  //                 </div>
  //                 <div className={styles.integrationGroup}></div>
  //               </div>
  //             </div>
  //           )}
  //           {actualView === EIntegrationsViews.ACCOUNTANCY && (
  //             <div className={styles.group}>
  //               <div className={styles.subheader}>System FK</div>
  //               <div className={styles.hint}>
  //                 Eksportuj wystawiane przez Ciebie faktury bezpośrednio do
  //                 Twojego systemu FK
  //               </div>
  //               <div className={styles.integrations}>
  //                 <div className={styles.integrationGroup}>
  //                   <IntegrationCard
  //                     type={IntegrationType.InvoiceSystem}
  //                     provider={IntegrationProvider.WFirma}
  //                     lastSync={''}
  //                     isActive={fkState.wfirmaActive}
  //                     name={fkState.name}
  //                     handleClick={handleClick}
  //                   ></IntegrationCard>
  //                 </div>
  //                 <div className={styles.integrationGroup}></div>
  //               </div>
  //             </div>
  //           )}
  //         </>
  //       )}
  //       {selectedIntegration == IntegrationType.Email && (
  //         <EmailSettings
  //           integrationId={emailState.id}
  //           onCanceled={onInnerViewCanceled}
  //           onSaved={onInnerViewSaved}
  //           handleDisconnect={handleDisconnect}
  //         ></EmailSettings>
  //       )}
  //       {selectedIntegration == IntegrationType.Calendar && (
  //         <CalendarSettings
  //           integrationId={calendarState.id}
  //           onCanceled={onInnerViewCanceled}
  //           onSaved={onInnerViewSaved}
  //           handleDisconnect={handleDisconnect}
  //         ></CalendarSettings>
  //       )}
  //       {selectedIntegration == IntegrationType.Editor && (
  //         <EditorSettings
  //           integrationId={editorState.id}
  //           onCanceled={onInnerViewCanceled}
  //           onSaved={onInnerViewSaved}
  //           handleDisconnect={handleDisconnect}
  //         ></EditorSettings>
  //       )}
  //       {selectedIntegration == IntegrationType.PublicPortal && (
  //         <CourtPortalSettings
  //           integrationId={courtPortalState.id}
  //           onCanceled={onInnerViewCanceled}
  //           onSaved={onInnerViewSaved}
  //           handleDisconnect={handleDisconnect}
  //           refetchI={refetchI}
  //         ></CourtPortalSettings>
  //       )}
  //       {toDelete.show && (
  //         <ConfirmModal
  //           title="Potwierdź usunięcie integracji"
  //           text="Czy na pewno chcesz usunać wybraną integrację?"
  //           acceptLabel="Usuń"
  //           cancelLabel="Anuluj"
  //           onAccept={() => {
  //             setToDelete({ id: 0, show: false });
  //             handleDisconnectConfirmed();
  //             toDelete.callback?.();
  //           }}
  //           onCancel={() => setToDelete({ id: 0, show: false })}
  //         />
  //       )}
  //     </div>
  //   </>
  // );
};

export default IntegrationsTab;
